import { atom } from "recoil";

const organizationIdState = atom({
  key: "organizationIdState",
  default: null,
});

export default organizationIdState;
